import { Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { BuildHexMap} from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { HxNote } from "../../../Comps/HxMap/HxNote";
import DisplayConfig from "../../../Data/HexMap/DisplayConfig";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { MutableRefObject, useRef } from "react";
import { NotePlayer } from "../../../Sound/NotePlayer";

export function BluesScaleChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div>
                <h1>The HexKey System: The Blues Scale</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const lastNoteTime:MutableRefObject<number> = useRef(0)
    const onNoteClick = (note:Note) => {
        const currTime:number = Date.now()
        const reset:boolean = ((currTime - lastNoteTime.current) > 3000)
        lastNoteTime.current = currTime
        notePlayer.current.playNote(note.params.tonic, true)
    }
    const visibleNotes:number[] = [0,1,2,4,5]
    const radius:number = 130
    const width:number = radius * 2.8
    const height:number = radius * 2.8
    const tonic:number = Music.C
    const getMap = () => {  
        const displayConfig:DisplayConfig = new DisplayConfig({keyRadius: radius, noteRadiusToKeyRadius:.25})  
        const mapData:HexMap = BuildHexMap({noteDisplayConfig:displayConfig, columns:1, rows:1, tonic:tonic, radius:radius})

        mapData.notes.forEach((note:Note, index:number)=>{
            const scaleIndex:number = visibleNotes.indexOf(index)
            const defined:boolean = (scaleIndex > -1)
            note.defined = defined
            if(defined){
                const isSelected:boolean = (index === 0 || index === 5)
                note.selectedState = (isSelected) ? Note.SelectedState_Hilited : Note.SelectedState_Selected
            }
        })
        return mapData
    }
    const getBlueNote = () => {
        const map:HexMap = getMap()
        const getX = () => {
            return map.notes[1].params.x
        }
        const blueNote:Note = new Note({noteIndex:100,x:getX(),y:radius, tonic:tonic + 3})
        blueNote.classNames = ['hilited']
        return blueNote
    }
    return(
        <OutlineBox title={'The Major and Minor Blues Scales'} width={600}>
            <div className={'Lesson'}>
                        <svg width={width} height={height}>
                            <g transform={TransformTranslate(width/2, height/2)}>
                                <HxMapGroup onNoteClick={onNoteClick} hexMap={getMap()}>
                                    <HxNote onNoteClick={onNoteClick} classNames={['blue-note']} note={getBlueNote()}/>
                                </HxMapGroup>  
                            </g>
                        </svg>
                    </div>
        </OutlineBox>
    )
}
